import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import IntroPage from '../components/IntroImageComponent';
import RegistrationDone from '../components/RegistrationDone';
import LinkExpired from '../components/LinkExpired';
import App, { $app } from '../app/App';
import { REGISTRATION_STATUS } from '../helpers/registration';

const POPUP = {
  done: 'done',
  expired: 'expired',
};

const RegistrationDonePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customer_id');
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    // bez customer_id odkaz vede na homepage
    if (!customerId) {
      navigate('/', { replace: true });
      return undefined;
    }
    if (!executeRecaptcha) return undefined;

    const controller = new AbortController();

    const sendConfirmation = async (id, signal) => {
      try {
        const token = await executeRecaptcha('account_registration_confirmation');
        await $app.sendAccountConfirmation(id, { signal }, token);
      } catch (err) {
        if (err?.exception !== 'canceled') console.error('Account confirmation failed', err);
      }
    };

    $app.getRegistrationStatusById(customerId, { signal: controller.signal })
      .then(({ status }) => {
        // state = 0 - odkaz uz neplati.
        if (status === REGISTRATION_STATUS.inactive || status === REGISTRATION_STATUS.notFound) {
          setPopup(POPUP.expired);
          return;
        }
        if (status === REGISTRATION_STATUS.incomplete) {
          sendConfirmation(customerId, controller.signal);
        }

        setPopup(POPUP.done);
      })
      .catch((err) => {
        if (err.exception !== 'canceled') App.$e(err.message);
      });

    return () => controller.abort();
  }, [customerId, navigate, executeRecaptcha]);

  const closeDone = () => navigate('/', { replace: true, state: null });

  return (
    <IntroPage>
      {popup === POPUP.done && <RegistrationDone onClose={closeDone} />}
      {popup === POPUP.expired && (
        <LinkExpired onRegister={() => navigate('/verify-email', { replace: true })} />
      )}
    </IntroPage>
  );
};

export default RegistrationDonePage;
